import "antd/dist/antd.min.css";
import React, { useLayoutEffect } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, useLocation } from "react-router-dom";
import "./index.css";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/grid";
import reportWebVitals from "./reportWebVitals";
import Root from "./routes/root";
import ErrorPage from "./routes/error-page";
import HomePage from "./routes/home-page";
import ProductDetails from "./routes/product-details-page";
import CategoryPage from "./routes/category-page";
import CategoryList from "./routes/category-list";
import AgencyDetailsPage from "./routes/agency-details-page";
import AgencyPage from "./routes/agency-page";
import SingInPage from "./routes/signin-page";
import SignUpPage from "./routes/signup-page";
import CartPage from "./routes/cart-page";
import { Provider } from "react-redux";
import {store} from "./app/store";
import Contact from "./components/Contact";
import SupportPage from "./routes/support-page";
import SearchPage from "./routes/search-page";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/product-details",
        element: <ProductDetails />,
      },
      {
        path: "/category",
        element: <CategoryPage />,
      },
      {
        path: "/category-list/",
        element: <CategoryList />,
      },
      {
        path: "/agency-details",
        element: <AgencyDetailsPage />,
      },
      {
        path: "/agency/",
        element: <AgencyPage />,
      },
      {
        path: "/cart",
        element: <CartPage />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/support",
        element: <SupportPage />,
      },
      {
        path: "/search",
        element: <SearchPage />,
        
      },
    ],
  },
  {
    path: "/signin/",
    element: <SingInPage />,
  },
  {
    path: "/signup/",
    element: <SignUpPage/>,
  },
]);

const Wrapper = ({ children }) => {
  const location = useLocation()
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])
  return children
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
